export const isContentEqualBy = (array1, array2, paramBy = 'id') =>
  array1.length === array2.length &&
  array1.every((item, idx) =>
    array1[idx].sys && array2[idx].sys
      ? item.sys[paramBy] === array2[idx].sys[paramBy]
      : item[paramBy] === array2[idx][paramBy],
  );
